import PropTypes from 'prop-types';
import DiffBox from '../DiffBox';

export const NegDiffCell = ({ row }) => {
  return row?.original?.diff < 0 ? <DiffBox value={row?.original?.diff} /> : null;
};

NegDiffCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      diff: PropTypes.number,
    }),
  }),
};

export const PosDiffCell = ({ row }) => {
  return row?.original?.diff > 0 ? <DiffBox value={row?.original?.diff} /> : null;
};

PosDiffCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      diff: PropTypes.number,
    }),
  }),
};
